// PARAQTA — auth ядросы (login finalize, logout, Telegram callback).
//
// onTelegramAuth — Telegram OAuth widget callback. HTML widget оны
// глобал ретінде шақырады, сондықтан window.onTelegramAuth МІНДЕТТІ.

import { setCurrentUser, setIsGuest, getWs, setWs } from '../../core/state.js';
import { connectWS } from '../../core/ws.js';
import { closeLoginModal } from './login-modal.js';
import { loadTimerStats } from '../timer/index.js';
import { toast } from '../../utils/toast.js';
import { show } from '../../core/router.js';
import { loadAppConfig } from '../submissions/index.js';
import { track } from '../../core/track.js';

export function loginDone(data) {
  setIsGuest(false);
  setCurrentUser(data);
  // Аналитика: кіру — funnel жабылады (бұрынғы анонимді көрулер telegram_id-ге жалғанады)
  try { track('login'); } catch (_) {}
  document.body.classList.add('app-mode');
  // Step LH1: guest-mode (CSS-те Top Nav жасырады) логин кезінде
  // алынып тасталады — толық app shell ашылады.
  document.body.classList.remove('guest-mode');
  document.getElementById('landingPage').style.display = 'none';
  closeLoginModal();
  document.getElementById('app').style.display = 'block';

  // NFC: бетбелгіден кірген болса — логин соңында ТЕК оқуға қайта орал (focused mode).
  try {
    const _nfcR = sessionStorage.getItem('pq_nfc_resume');
    if (_nfcR) {
      sessionStorage.removeItem('pq_nfc_resume');
      document.getElementById('nfcOnb')?.remove();
      document.body.classList.add('pq-nfc');
      import('../oqu/index.js').then(m => m.nfcEntry(_nfcR)).catch(() => {});
      return;
    }
  } catch (_) {}

  // 01.09: МҰҒАЛІМ сілтемесімен келген — рұқсат аламыз да, «Бірге» бетіне
  // апарамыз (сол жерде «🏫 Сынып ашу» батырмасы тұр). Founder-ге хабар кетеді.
  try {
    if (localStorage.getItem('pq_mugalim')) {
      localStorage.removeItem('pq_mugalim');
      fetch('/api/mugalim/claim', { method: 'POST', credentials: 'include' })
        .then((r) => r.json()).then((d) => {
          if (d && d.ok) toast('🏫 Мұғалім рұқсаты ашылды — «Бірге» бетінде «Сынып ашу»');
        }).catch(() => {});
      return show('groups');
    }
  } catch (_) {}

  // 01.09: ОҚУШЫ сынып кодымен келген (/c/КОД) — «Бірге» бетіне апарамыз.
  // ❗Авто-қосылу ӘДЕЙІ ЖОҚ: сол бетте circle модулінің КЕЛІСІМ картасы тұр
  // («иесі нені көреді / КӨРМЕЙДІ» + «Қосылу») — бала не көрінетінін біліп
  // барып қосылады. Кодты `pq_circle_code` кілті ұстап тұр (main.js жазды),
  // картаны pendingInviteHtml оқиды.
  try {
    if (localStorage.getItem('pq_circle_code')) {
      return show('groups');
    }
  } catch (_) {}

  // ❗Кітап бетінен «оқуды бастау» басып логинге кеткен болса — сол кітапты
  // ӨЗІ ашамыз. Онсыз адам логиннен кейін бос бетке түсіп, не үшін кіргенін
  // ұмытады. (2026-08-31 аудиті: кітап беттері аптасына ~946 адам.)
  try {
    import('../library-read/index.js')
      .then(m => m.resumeLibraryRead())
      .catch(() => {});
  } catch (_) {}

  // РЕФ ҚАҚПАСЫ: блогер сілтемесінен «Тіркелу» басып логин жасаса —
  // логин соңында марафон бетін аш + тіркеу модалін авто-аш (енді мүше).
  try {
    const _refR = sessionStorage.getItem('pq_ref_resume');
    if (_refR) {
      sessionStorage.removeItem('pq_ref_resume');
      document.body.classList.remove('pq-ref', 'pq-ref-guest');
      import('../marathon/index.js').then(m => m.refEntry(null, true)).catch(() => {});
      return;
    }
  } catch (_) {}

  // Блогер рефінен тіркелу: логин соңында марафон бетіне қайтып, төлем модалын
  // авто-ашады (loadMarathon pq_marathon_regopen флагын оқиды — _m дайын болғанда).
  try {
    const _mr = sessionStorage.getItem('pq_marathon_reg');
    if (_mr) {
      sessionStorage.removeItem('pq_marathon_reg');
      sessionStorage.setItem('pq_marathon_regopen', '1');
      document.body.classList.remove('pq-ref', 'pq-ref-guest');
      show('marathon');
      return;
    }
  } catch (_) {}

  // «Бұрын тіркелдім — Telegram-мен кіру»: логин соңында марафон бетіне қайтады
  // (тіркелген болса «Тіркелдіңіз» + чат сілтемесін көреді — қайта төлемейді).
  try {
    const _mc = sessionStorage.getItem('pq_marathon_check');
    if (_mc) {
      sessionStorage.removeItem('pq_marathon_check');
      document.body.classList.remove('pq-ref', 'pq-ref-guest');
      show('marathon');
      return;
    }
  } catch (_) {}

  const name = data.name || data.telegram_id;
  const ini = name.toString().split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  document.getElementById('navAv').textContent = ini;
  document.getElementById('navName').textContent = name;
  if (data.streak) {
    document.getElementById('navStreak').textContent = '\uD83D\uDD25 ' + data.streak + ' күн';
  }
  const lb = document.getElementById('liveBadge');
  if (lb) lb.style.display = 'flex';

  // 04.10.26: фондағы loadDashboard() → loadTodayV2() АЛЫНДЫ. Ол өлі «Бүгін»
  // бетін көрінбейтін жерде сызатын (әр кіруде бекер API сұраныстары).
  // Нав аты/стригі жоғарыда логин дерегінен қойылды; екі мереке (стрик
  // қорғалды, күндік мақсат) енді Оқу бетінен шақырылады (oqu loadCurrentBook).
  loadTimerStats();
  // Step BP4 fix: pre-login loadAppConfig() is_admin=false болатын.
  // Login кейін қайта шақырамыз — body.admin-user класы орнатылып,
  // CSS hide ережесі жойылады. show('admin') кейін race болмас үшін
  // alдын ала await жасаймыз. Hash deep link Telegram notification-нан
  // (paraqta.kz/#admin) admin Ердәулетке жетеді.
  loadAppConfig().then(() => {
    const h = (location.hash || '').replace(/^#/, '');
    if (h === 'admin') return show('admin');
    // Кітап deep-link (share сілтемесінен: paraqta.kz/#book/slug) — логин болған адамда да ашылсын
    if (h.startsWith('book/')) {
      const slug = h.slice(5);
      if (slug) return import('../book-page/index.js').then(m => m.openBookPage(slug));
    }
    // Ескі #dash / #books hash-тары — show() ішінде Оқуға бұрылады.
    if (h && ['dash','oqu','catalog','profile','groups','feed','jandos','marathon','books','leaders'].includes(h)) {
      return show(h);
    }
    // ❗Клуб шақыруымен келген болса — «Бірге» бетін ашамыз. Қосылу коды
    // `loadGroups()` ішінде өтеледі, ал ол ТЕК сол бет ашылғанда жүреді.
    // Онсыз адам шақыруды басып, Оқу бетіне түсетін де, код localStorage-та
    // үнсіз жатып қалатын — клубқа қосылмай кете беретін.
    try {
      if (localStorage.getItem('pq_join_code') || localStorage.getItem('pq_join_club')) {
        return show('groups');
      }
    } catch (_) {}

    // Stage 8 v2 IA: ашқанда → Оқу (басты бет). Бүгін/Парақтау навтан алынды,
    // сондықтан соңғы бет солар болса — Оқуға қайтарамыз.
    let last = null;
    try { last = localStorage.getItem('paraqta:last_page'); } catch (_) {}
    const valid = ['oqu','catalog','profile','groups','jandos','marathon','leaders'];  // 04.10: 'books' өшті
    let openedBefore = false;
    try { openedBefore = !!localStorage.getItem('paraqta:opened_before'); } catch (_) {}
    if (!openedBefore) {
      try { localStorage.setItem('paraqta:opened_before', '1'); } catch (_) {}
      show('oqu');
    } else {
      show(valid.includes(last) ? last : 'oqu');
    }
  });
  connectWS();
  // ❗Арна қадамы. Бұрын мұнда initPushNotifications тұратын, ол боты барларға
  // да рұқсат сұрайтын, ал бот баннері тек «Бүгін» бетінде шығатындықтан
  // жаңа адамға іс жүзінде ЕШҚАШАН көрінбейтін (әдепкі бет — «Оқу»).
  // Енді бір қадам: боты барды мазаламайды, жоғынан ғана бір рет сұрайды.
  // Push-ты сол қадам өзі шақырады — қосарланып сұралмасын.
  import('../channel/index.js').then(m => m.initChannelStep()).catch(() => {});
}

export async function logout() {
  const sock = getWs();
  if (sock) {
    sock.close();
    setWs(null);
  }
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
  location.reload();
}

export async function onTelegramAuth(data) {
  const r = await fetch('/api/auth/telegram', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  });
  if (r.ok) {
    loginDone(await r.json());
  } else {
    const e = await r.json();
    toast(e.detail || 'Қате болды');
  }
}
